export const INDUSTRIES = {
    healthcare: 'Healthcare',
    manufacturing: 'Manufacturing',
    software: 'Software',
    financial_services: 'Financial Services',
    retail: 'Retail',
    education: 'Education',
    government: 'Government',
    logistics: 'Logistics',
    real_estate: 'Real Estate',
    media: 'Media & Entertainment',
    energy: 'Energy',
    nonprofit: 'Nonprofit',
    other: 'Other'
};

export const INDUSTRY_ORDER = Object.keys(INDUSTRIES);

export function getIndustryLabel(key) {
    return INDUSTRIES[key] || key;
}
